import { Grid } from "@mui/material";
import React, { useMemo } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { useWatch } from "react-hook-form";

function Algemeen() {
  const selectedSalesAreaId = useWatch({ name: "vestiging_id" });

  const tafelUrl = useMemo(() => {
    if (selectedSalesAreaId) {
      return "core/tafels/search?fields=id as value, naam as label&per_page=50&vestiging_id=" + selectedSalesAreaId;
    } else {
      return "core/tafels/search?fields=id as value, naam as label&per_page=50";
    }
  }, [selectedSalesAreaId]);

  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <FormSwitchTC name={"is_actief"} tDefault={"Actief"} tKey={"shortlinks.form.algemeen.label.is_actief"} />
          <FormAsyncTC
            async={{
              url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=50",
              searchField: "systeemNaam",
            }}
            name={"vestiging_id"}
            tDefault={"Vestiging"}
            tKey={"shortlinks.form.algemeen.label.vestiging"}
          />
          <FormTextTC name={"shortlink"} tDefault={"Shortlink"} tKey={"shortlinks.form.algemeen.label.shortlink"} />
          <FormAsyncTC
            async={{
              url: tafelUrl,
              searchField: "naam",
            }}
            key={selectedSalesAreaId}
            name={"tafel_id"}
            tDefault={"Tafel"}
            tKey={"shortlinks.form.algemeen.label.tafel"}
          />
        </Grid>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
